import React, { Component } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Row } from "reactstrap";
import {
    Button,
    TableRow,
    Card,
    Table,
    TableBody,
    Typography,
} from "@material-ui/core";
import { StyledHeader } from "../../../styles";
import ReactToPrint from "react-to-print";
import styled from "styled-components";
import logo from "./logo.jpeg";
// import companyLogo from "../../../../../config/headerIcon.jpeg"
import { noImg } from "vrcore-dashboard/dist/utilities";

const Print = styled.div`
    @page {
        margin: 0; 
        size: 3in 1.6in !important;
        content: {"Prowork"};
      }
`;

class ViewQRModal extends Component {
    render() {
        const { isOpen } = this.props;
        const { qr } = this.props;
        const { close } = this.props;
        let info_history = "";

        return (
            <Modal isOpen={isOpen}>
                <ModalHeader>View Equipment</ModalHeader>
                <ModalBody>
                    <Print ref={(el) => (this.componentRef = el)}>
                        <div id="print">
                            <img
                                src={logo}
                                alt="logo"
                                style={{
                                    width: "207px",
                                    height: "30px",
                                }}
                            />
                            <Row>
                                <TableRow style={{ display: "contents" }}>
                                    <img
                                        alt="profile avatar"
                                        src={qr.qr_code_url}
                                        style={{
                                            height: "145px",
                                            width: "145px",
                                            marginLeft: "28px",
                                        }}
                                    />
                                    <p
                                        style={{
                                            marginLeft: "0px",
                                            fontSize: "12px",
                                            marginTop: "16px",
                                        }}
                                    >
                                        <b>Name:</b>
                                        <br />
                                        {qr.name}
                                        <br />
                                        <b>Status:</b> {qr.status}
                                        <br />
                                        <b>Last Examination:</b>{" "}
                                        {qr.date_last_examination} <br />
                                        <b>Last Service:</b>
                                        {qr.date_last_service} <br />
                                    </p>
                                    {/* <img
                                    src={companyLogo}
                                    alt="logo"
                                    style={{
                                        float: "right",
                                        width: "103px",
                                        height: "80px",
                                        marginLeft:"16px"
                                    }}
                                /> */}
                                </TableRow>
                            </Row>
                            <p
                                style={{
                                    marginLeft: "155px",
                                    marginTop: "-28px",
                                    fontSize: "12px",
                                }}
                            >
                                <b style={{ color: "red" }}>
                                    If Lost/Stolen Please Call:{" "}
                                </b>
                                <br />
                                <b style={{ color: "red" }}>or &nbsp;Email:</b>
                            </p>
                            <hr
                                style={{
                                    backgroundColor: "#0088CB",
                                    width: "90%",
                                    height: "5px",
                                    marginTop: "-11px",
                                }}
                            />
                        </div>
                    </Print>
                    <br />
                    {info_history && info_history.length !== 0 ? (
                        <div>
                            <Card>
                                <StyledHeader
                                    style={{ backgroundColor: "#0188CC" }}
                                >
                                    <Typography
                                        variant="headline"
                                        style={{
                                            paddingLeft: "144px",
                                            fontWeigth: "bold",
                                            color: "white",
                                        }}
                                    >
                                        Cleaning History
                                    </Typography>
                                </StyledHeader>
                            </Card>
                        </div>
                    ) : (
                        ""
                    )}
                    <div>
                        <Table>
                            <TableBody>
                                {info_history &&
                                    Object.values(info_history).map(
                                        (history, index) => {
                                            return (
                                                <TableRow key={index}>
                                                    <div
                                                        className="icon-text-container"
                                                        style={{
                                                            borderWidth:
                                                                "medium",
                                                            border:
                                                                "7px solid #0188cc",
                                                            borderRadius: "9px",
                                                            marginTop: "10px",
                                                        }}
                                                    >
                                                        <div className="float-left icon-container">
                                                            <img
                                                                style={{
                                                                    borderRadius:
                                                                        "12px",
                                                                    width:
                                                                        "161px",
                                                                    height:
                                                                        "140px",
                                                                    marginTop:
                                                                        "2px",
                                                                    marginLeft:
                                                                        "108px",
                                                                    border:
                                                                        "2px solid #0188cc",
                                                                }}
                                                                src={
                                                                    history.photo_url ==
                                                                    null
                                                                        ? noImg
                                                                        : history.photo_url
                                                                }
                                                                alt="Proof"
                                                            />
                                                        </div>
                                                        <div className="float-left text-container">
                                                            <h5
                                                                style={{
                                                                    border:
                                                                        "2px solid #0188cc",
                                                                    borderRadius:
                                                                        "12px",
                                                                    padding:
                                                                        "7px",
                                                                    width:
                                                                        "400px",
                                                                }}
                                                            >
                                                                <b>
                                                                    Last
                                                                    Cleaned:
                                                                </b>{" "}
                                                                <span className="subHeading">
                                                                    {
                                                                        history.timestamp
                                                                    }
                                                                </span>
                                                            </h5>
                                                            <h5
                                                                style={{
                                                                    border:
                                                                        "2px solid #0188cc",
                                                                    borderRadius:
                                                                        "12px",
                                                                    padding:
                                                                        "7px",
                                                                    width:
                                                                        "400px",
                                                                }}
                                                            >
                                                                <b>
                                                                    Last Cleaned
                                                                    By:
                                                                </b>{" "}
                                                                <span className="subHeading">
                                                                    {
                                                                        history.user_name
                                                                    }
                                                                </span>
                                                            </h5>
                                                        </div>

                                                        <div className="clear"></div>
                                                    </div>
                                                </TableRow>
                                            );
                                        }
                                    )}
                            </TableBody>
                        </Table>
                    </div>
                </ModalBody>
                <ModalFooter>
                    <ReactToPrint
                        trigger={() => (
                            <Button variant="contained" color="primary">
                                Print
                            </Button>
                        )}
                        content={() => this.componentRef}
                    />
                    <Button variant="contained" onClick={() => close()}>
                        Cancel
                    </Button>
                </ModalFooter>
            </Modal>
        );
    }
}
export default ViewQRModal;
